export default __webpack_public_path__ + "static/media/2458_2460 inner.2224f25f.jpg";